export const ALL_RECENT_ACTIVITY_LOAD = 'ALL_RECENT_ACTIVITY_LOAD';
export const SPE_RECENT_ACTIVITY_LOAD = 'SPE_RECENT_ACTIVITY_LOAD';
export const SW_RECENT_ACTIVITY_LOAD = 'SW_RECENT_ACTIVITY_LOAD';
